import dynamic from 'next/dynamic'

export const Banner = dynamic(() => import('./banner'))
